import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@quintoandar-tokko/jopijs';
import BaseModal from '../../BaseModal';
import {
  clearPerformanceModalFilters,
  setPerformanceModals,
} from '@/store/slices/components/dashboard/DashboardSlice';
import buildQuery from '@/components/Dashboard/utils/buildQuery';
import { getPerformanceDoneVisitsTable } from '@/store/slices/components/dashboard/service';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import DownloadButton from '@/components/Dashboard/DashboardTables/components/DownloadButton';
import styles from '../../performanceModals.module.scss';
import buildTableQuery from '@/components/Dashboard/utils/buildTableQuery';
import useAsyncTableExcelDownload from '@/components/Dashboard/customHooks/useAsyncTableExcelDownload';
import { TABLES } from '@/components/Dashboard/constants';
import TableSearchEmptyState from '@/components/Dashboard/DashboardTables/TableSearchEmptyState';
import DoneVisitsTable from '@/components/Dashboard/DashboardTables/DoneVisitsTable';
import SearchInput from '../../SearchInput';
import { getDoneVisitsTypesOptions } from '../utils';
import useTrackPerformanceTable from '@/components/Dashboard/customHooks/useTrackDashboard';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';

export default function DoneVisitsModal() {
  const dispatch = useDispatch();
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);
  const { doneVisits } = useSelector(
    (state) => state.DashboardSlice.performanceModals
  );
  const dropdownOptions = getDoneVisitsTypesOptions(true);
  const {
    count,
    list,
    loading,
    sortBy,
    sortDirection,
    searchQuery,
    searchTypeFlag,
  } = doneVisits;
  const track = useTrackPerformanceTable();
  const { handleDownloadExcel: downloadExcel, isDownloading } =
    useAsyncTableExcelDownload(TABLES.DONE_VISITS);

  useEffect(() => {
    const fetchData = () => {
      const query = buildQuery(selectedIds);
      const tableQuery = buildTableQuery(doneVisits);

      dispatch(getPerformanceDoneVisitsTable({ query, tableQuery }));
    };

    fetchData();
  }, [sortBy, sortDirection, searchQuery, searchTypeFlag]);

  const handleDownloadExcel = () => {
    const query = buildQuery(selectedIds);
    const tableQuery = buildTableQuery(doneVisits);
    downloadExcel(query, tableQuery);
    track.doneVisits(TRACK_ELEMENT.DOWNLOAD_BUTTON);
  };

  const handleClearFilters = () => {
    const modal = 'doneVisits';
    const filters = ['searchQuery', 'searchType'];
    dispatch(clearPerformanceModalFilters({ modal, filters }));
  };

  return (
    <BaseModal
      id="done-visits-modal"
      title={`${count} ${Trans(translations, 'VisitsMade')}`}
      handleClose={() =>
        dispatch(
          setPerformanceModals({
            key: 'doneVisits',
            subkey: 'isOpen',
            value: false,
          })
        )
      }
    >
      <Box className={styles.modalControls}>
        <SearchInput modal="doneVisits" dropdownOptions={dropdownOptions} />

        <DownloadButton
          onClick={handleDownloadExcel}
          disabled={isDownloading}
        />
      </Box>
      {searchQuery && list?.length === 0 && !loading ? (
        <TableSearchEmptyState onClearFilters={handleClearFilters} />
      ) : (
        <BaseModal.TableContainer>
          <DoneVisitsTable />
        </BaseModal.TableContainer>
      )}
    </BaseModal>
  );
}
